export const storageItems = {
    user: 'user',
    address: 'address',
    speciality: 'speciality',
    lawfirm: 'lawfirm',
    lawyer: 'lawyer',
    landingPage: 'landingPage',
};
